/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ImmersiveRouteImport } from './routes/_immersive'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as GemRouteImport } from './routes/gem'
import { Route as DemoIndexRouteImport } from './routes/demo/index'
import { Route as Demo3dRouteImport } from './routes/demo/3d'
import { Route as DemoDesignSystemRouteImport } from './routes/demo/design-system'
import { Route as DemoTestsRouteImport } from './routes/demo/tests'
import { Route as ImmersiveDemo3dRouteImport } from './routes/_immersive/demo/3d'
import { Route as Demo3dIndexRouteImport } from './routes/demo/3d/index'
import { Route as Demo3dHeroRouteImport } from './routes/demo/3d/hero'
import { Route as DemoDesignSystemIndexRouteImport } from './routes/demo/design-system/index'
import { Route as DemoDesignSystemFoundationsRouteImport } from './routes/demo/design-system/foundations'
import { Route as DemoDesignSystemInteractiveRouteImport } from './routes/demo/design-system/interactive'
import { Route as DemoDesignSystemRadixRouteImport } from './routes/demo/design-system/radix'
import { Route as DemoDesignSystemSpecialtyRouteImport } from './routes/demo/design-system/specialty'
import { Route as DemoDesignSystemTestsRouteImport } from './routes/demo/design-system/tests'
import { Route as DemoDesignSystemThemingRouteImport } from './routes/demo/design-system/theming'
import { Route as DemoTestsIndexRouteImport } from './routes/demo/tests/index'
import { Route as DemoTestsComponentSizeTestRouteImport } from './routes/demo/tests/component-size-test'
import { Route as ImmersiveDemo3dBobRouteImport } from './routes/_immersive/demo/3d/bob'
import { Route as ImmersiveDemo3dDrillRouteImport } from './routes/_immersive/demo/3d/drill'
import { Route as ImmersiveDemo3dGemRouteImport } from './routes/_immersive/demo/3d/gem'
import { Route as ImmersiveDemo3dRuneRouteImport } from './routes/_immersive/demo/3d/rune'
import { Route as DemoDesignSystemFoundationsIndexRouteImport } from './routes/demo/design-system/foundations/index'
import { Route as DemoDesignSystemFoundationsButtonsRouteImport } from './routes/demo/design-system/foundations/buttons'
import { Route as DemoDesignSystemFoundationsCardsRouteImport } from './routes/demo/design-system/foundations/cards'
import { Route as DemoDesignSystemFoundationsLabelsRouteImport } from './routes/demo/design-system/foundations/labels'
import { Route as DemoDesignSystemInteractiveIndexRouteImport } from './routes/demo/design-system/interactive/index'
import { Route as DemoDesignSystemInteractiveCollapsibleRouteImport } from './routes/demo/design-system/interactive/collapsible'
import { Route as DemoDesignSystemInteractiveDropdownRouteImport } from './routes/demo/design-system/interactive/dropdown'
import { Route as DemoDesignSystemInteractiveNavigationMenuRouteImport } from './routes/demo/design-system/interactive/navigation-menu'
import { Route as DemoDesignSystemInteractiveSliderRouteImport } from './routes/demo/design-system/interactive/slider'
import { Route as DemoDesignSystemInteractiveSwitchRouteImport } from './routes/demo/design-system/interactive/switch'
import { Route as DemoDesignSystemInteractiveTabsRouteImport } from './routes/demo/design-system/interactive/tabs'
import { Route as DemoDesignSystemInteractiveToastRouteImport } from './routes/demo/design-system/interactive/toast'
import { Route as DemoDesignSystemRadixIndexRouteImport } from './routes/demo/design-system/radix/index'
import { Route as DemoDesignSystemRadixAccordionRouteImport } from './routes/demo/design-system/radix/accordion'
import { Route as DemoDesignSystemRadixHoverCardRouteImport } from './routes/demo/design-system/radix/hover-card'
import { Route as DemoDesignSystemRadixPopoverRouteImport } from './routes/demo/design-system/radix/popover'
import { Route as DemoDesignSystemRadixRadixExamplesRouteImport } from './routes/demo/design-system/radix/radix-examples'
import { Route as DemoDesignSystemRadixScrollAreaRouteImport } from './routes/demo/design-system/radix/scroll-area'
import { Route as DemoDesignSystemRadixSelectRouteImport } from './routes/demo/design-system/radix/select'
import { Route as DemoDesignSystemSpecialtyIndexRouteImport } from './routes/demo/design-system/specialty/index'
import { Route as DemoDesignSystemSpecialtyDomainBadgeRouteImport } from './routes/demo/design-system/specialty/domain-badge'
import { Route as DemoDesignSystemTestsIndexRouteImport } from './routes/demo/design-system/tests/index'
import { Route as DemoDesignSystemTestsComponentSizeRouteImport } from './routes/demo/design-system/tests/component-size'
import { Route as DemoDesignSystemThemingIndexRouteImport } from './routes/demo/design-system/theming/index'
import { Route as DemoDesignSystemThemingExamplesRouteImport } from './routes/demo/design-system/theming/examples'
import { Route as DemoDesignSystemThemingOpacityUtilitiesRouteImport } from './routes/demo/design-system/theming/opacity-utilities'
import { Route as DemoDesignSystemThemingTailwindPluginRouteImport } from './routes/demo/design-system/theming/tailwind-plugin'
import { Route as DemoDesignSystemThemingThemeUtilitiesRouteImport } from './routes/demo/design-system/theming/theme-utilities'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImmersiveRoute = ImmersiveRouteImport.update({
  id: '/_immersive',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const GemRoute = GemRouteImport.update({
  id: '/gem',
  path: '/gem',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoIndexRoute = DemoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemoRoute,
} as any)
const Demo3dRoute = Demo3dRouteImport.update({
  id: '/3d',
  path: '/3d',
  getParentRoute: () => DemoRoute,
} as any)
const DemoDesignSystemRoute = DemoDesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => DemoRoute,
} as any)
const DemoTestsRoute = DemoTestsRouteImport.update({
  id: '/tests',
  path: '/tests',
  getParentRoute: () => DemoRoute,
} as any)
const ImmersiveDemo3dRoute = ImmersiveDemo3dRouteImport.update({
  id: '/demo/3d',
  path: '/demo/3d',
  getParentRoute: () => ImmersiveRoute,
} as any)
const Demo3dIndexRoute = Demo3dIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Demo3dRoute,
} as any)
const Demo3dHeroRoute = Demo3dHeroRouteImport.update({
  id: '/hero',
  path: '/hero',
  getParentRoute: () => Demo3dRoute,
} as any)
const DemoDesignSystemIndexRoute = DemoDesignSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemoDesignSystemRoute,
} as any)
const DemoDesignSystemFoundationsRoute =
  DemoDesignSystemFoundationsRouteImport.update({
    id: '/foundations',
    path: '/foundations',
    getParentRoute: () => DemoDesignSystemRoute,
  } as any)
const DemoDesignSystemInteractiveRoute =
  DemoDesignSystemInteractiveRouteImport.update({
    id: '/interactive',
    path: '/interactive',
    getParentRoute: () => DemoDesignSystemRoute,
  } as any)
const DemoDesignSystemRadixRoute = DemoDesignSystemRadixRouteImport.update({
  id: '/radix',
  path: '/radix',
  getParentRoute: () => DemoDesignSystemRoute,
} as any)
const DemoDesignSystemSpecialtyRoute =
  DemoDesignSystemSpecialtyRouteImport.update({
    id: '/specialty',
    path: '/specialty',
    getParentRoute: () => DemoDesignSystemRoute,
  } as any)
const DemoDesignSystemTestsRoute = DemoDesignSystemTestsRouteImport.update({
  id: '/tests',
  path: '/tests',
  getParentRoute: () => DemoDesignSystemRoute,
} as any)
const DemoDesignSystemThemingRoute = DemoDesignSystemThemingRouteImport.update({
  id: '/theming',
  path: '/theming',
  getParentRoute: () => DemoDesignSystemRoute,
} as any)
const DemoTestsIndexRoute = DemoTestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemoTestsRoute,
} as any)
const DemoTestsComponentSizeTestRoute =
  DemoTestsComponentSizeTestRouteImport.update({
    id: '/component-size-test',
    path: '/component-size-test',
    getParentRoute: () => DemoTestsRoute,
  } as any)
const ImmersiveDemo3dBobRoute = ImmersiveDemo3dBobRouteImport.update({
  id: '/bob',
  path: '/bob',
  getParentRoute: () => ImmersiveDemo3dRoute,
} as any)
const ImmersiveDemo3dDrillRoute = ImmersiveDemo3dDrillRouteImport.update({
  id: '/drill',
  path: '/drill',
  getParentRoute: () => ImmersiveDemo3dRoute,
} as any)
const ImmersiveDemo3dGemRoute = ImmersiveDemo3dGemRouteImport.update({
  id: '/gem',
  path: '/gem',
  getParentRoute: () => ImmersiveDemo3dRoute,
} as any)
const ImmersiveDemo3dRuneRoute = ImmersiveDemo3dRuneRouteImport.update({
  id: '/rune',
  path: '/rune',
  getParentRoute: () => ImmersiveDemo3dRoute,
} as any)
const DemoDesignSystemFoundationsIndexRoute =
  DemoDesignSystemFoundationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemFoundationsRoute,
  } as any)
const DemoDesignSystemFoundationsButtonsRoute =
  DemoDesignSystemFoundationsButtonsRouteImport.update({
    id: '/buttons',
    path: '/buttons',
    getParentRoute: () => DemoDesignSystemFoundationsRoute,
  } as any)
const DemoDesignSystemFoundationsCardsRoute =
  DemoDesignSystemFoundationsCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => DemoDesignSystemFoundationsRoute,
  } as any)
const DemoDesignSystemFoundationsLabelsRoute =
  DemoDesignSystemFoundationsLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => DemoDesignSystemFoundationsRoute,
  } as any)
const DemoDesignSystemInteractiveIndexRoute =
  DemoDesignSystemInteractiveIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveCollapsibleRoute =
  DemoDesignSystemInteractiveCollapsibleRouteImport.update({
    id: '/collapsible',
    path: '/collapsible',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveDropdownRoute =
  DemoDesignSystemInteractiveDropdownRouteImport.update({
    id: '/dropdown',
    path: '/dropdown',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveNavigationMenuRoute =
  DemoDesignSystemInteractiveNavigationMenuRouteImport.update({
    id: '/navigation-menu',
    path: '/navigation-menu',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveSliderRoute =
  DemoDesignSystemInteractiveSliderRouteImport.update({
    id: '/slider',
    path: '/slider',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveSwitchRoute =
  DemoDesignSystemInteractiveSwitchRouteImport.update({
    id: '/switch',
    path: '/switch',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveTabsRoute =
  DemoDesignSystemInteractiveTabsRouteImport.update({
    id: '/tabs',
    path: '/tabs',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemInteractiveToastRoute =
  DemoDesignSystemInteractiveToastRouteImport.update({
    id: '/toast',
    path: '/toast',
    getParentRoute: () => DemoDesignSystemInteractiveRoute,
  } as any)
const DemoDesignSystemRadixIndexRoute =
  DemoDesignSystemRadixIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixAccordionRoute =
  DemoDesignSystemRadixAccordionRouteImport.update({
    id: '/accordion',
    path: '/accordion',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixHoverCardRoute =
  DemoDesignSystemRadixHoverCardRouteImport.update({
    id: '/hover-card',
    path: '/hover-card',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixPopoverRoute =
  DemoDesignSystemRadixPopoverRouteImport.update({
    id: '/popover',
    path: '/popover',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixRadixExamplesRoute =
  DemoDesignSystemRadixRadixExamplesRouteImport.update({
    id: '/radix-examples',
    path: '/radix-examples',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixScrollAreaRoute =
  DemoDesignSystemRadixScrollAreaRouteImport.update({
    id: '/scroll-area',
    path: '/scroll-area',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemRadixSelectRoute =
  DemoDesignSystemRadixSelectRouteImport.update({
    id: '/select',
    path: '/select',
    getParentRoute: () => DemoDesignSystemRadixRoute,
  } as any)
const DemoDesignSystemSpecialtyIndexRoute =
  DemoDesignSystemSpecialtyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemSpecialtyRoute,
  } as any)
const DemoDesignSystemSpecialtyDomainBadgeRoute =
  DemoDesignSystemSpecialtyDomainBadgeRouteImport.update({
    id: '/domain-badge',
    path: '/domain-badge',
    getParentRoute: () => DemoDesignSystemSpecialtyRoute,
  } as any)
const DemoDesignSystemTestsIndexRoute =
  DemoDesignSystemTestsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemTestsRoute,
  } as any)
const DemoDesignSystemTestsComponentSizeRoute =
  DemoDesignSystemTestsComponentSizeRouteImport.update({
    id: '/component-size',
    path: '/component-size',
    getParentRoute: () => DemoDesignSystemTestsRoute,
  } as any)
const DemoDesignSystemThemingIndexRoute =
  DemoDesignSystemThemingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)
const DemoDesignSystemThemingExamplesRoute =
  DemoDesignSystemThemingExamplesRouteImport.update({
    id: '/examples',
    path: '/examples',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)
const DemoDesignSystemThemingOpacityUtilitiesRoute =
  DemoDesignSystemThemingOpacityUtilitiesRouteImport.update({
    id: '/opacity-utilities',
    path: '/opacity-utilities',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)
const DemoDesignSystemThemingTailwindPluginRoute =
  DemoDesignSystemThemingTailwindPluginRouteImport.update({
    id: '/tailwind-plugin',
    path: '/tailwind-plugin',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)
const DemoDesignSystemThemingThemeUtilitiesRoute =
  DemoDesignSystemThemingThemeUtilitiesRouteImport.update({
    id: '/theme-utilities',
    path: '/theme-utilities',
    getParentRoute: () => DemoDesignSystemThemingRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/demo': typeof DemoRouteWithChildren
  '/gem': typeof GemRoute
  '/demo/3d': typeof ImmersiveDemo3dRouteWithChildren
  '/demo/design-system': typeof DemoDesignSystemRouteWithChildren
  '/demo/tests': typeof DemoTestsRouteWithChildren
  '/demo/': typeof DemoIndexRoute
  '/demo/3d/hero': typeof Demo3dHeroRoute
  '/demo/design-system/foundations': typeof DemoDesignSystemFoundationsRouteWithChildren
  '/demo/design-system/interactive': typeof DemoDesignSystemInteractiveRouteWithChildren
  '/demo/design-system/radix': typeof DemoDesignSystemRadixRouteWithChildren
  '/demo/design-system/specialty': typeof DemoDesignSystemSpecialtyRouteWithChildren
  '/demo/design-system/tests': typeof DemoDesignSystemTestsRouteWithChildren
  '/demo/design-system/theming': typeof DemoDesignSystemThemingRouteWithChildren
  '/demo/tests/component-size-test': typeof DemoTestsComponentSizeTestRoute
  '/demo/3d/': typeof Demo3dIndexRoute
  '/demo/design-system/': typeof DemoDesignSystemIndexRoute
  '/demo/tests/': typeof DemoTestsIndexRoute
  '/demo/3d/bob': typeof ImmersiveDemo3dBobRoute
  '/demo/3d/drill': typeof ImmersiveDemo3dDrillRoute
  '/demo/3d/gem': typeof ImmersiveDemo3dGemRoute
  '/demo/3d/rune': typeof ImmersiveDemo3dRuneRoute
  '/demo/design-system/foundations/buttons': typeof DemoDesignSystemFoundationsButtonsRoute
  '/demo/design-system/foundations/cards': typeof DemoDesignSystemFoundationsCardsRoute
  '/demo/design-system/foundations/labels': typeof DemoDesignSystemFoundationsLabelsRoute
  '/demo/design-system/interactive/collapsible': typeof DemoDesignSystemInteractiveCollapsibleRoute
  '/demo/design-system/interactive/dropdown': typeof DemoDesignSystemInteractiveDropdownRoute
  '/demo/design-system/interactive/navigation-menu': typeof DemoDesignSystemInteractiveNavigationMenuRoute
  '/demo/design-system/interactive/slider': typeof DemoDesignSystemInteractiveSliderRoute
  '/demo/design-system/interactive/switch': typeof DemoDesignSystemInteractiveSwitchRoute
  '/demo/design-system/interactive/tabs': typeof DemoDesignSystemInteractiveTabsRoute
  '/demo/design-system/interactive/toast': typeof DemoDesignSystemInteractiveToastRoute
  '/demo/design-system/radix/accordion': typeof DemoDesignSystemRadixAccordionRoute
  '/demo/design-system/radix/hover-card': typeof DemoDesignSystemRadixHoverCardRoute
  '/demo/design-system/radix/popover': typeof DemoDesignSystemRadixPopoverRoute
  '/demo/design-system/radix/radix-examples': typeof DemoDesignSystemRadixRadixExamplesRoute
  '/demo/design-system/radix/scroll-area': typeof DemoDesignSystemRadixScrollAreaRoute
  '/demo/design-system/radix/select': typeof DemoDesignSystemRadixSelectRoute
  '/demo/design-system/specialty/domain-badge': typeof DemoDesignSystemSpecialtyDomainBadgeRoute
  '/demo/design-system/tests/component-size': typeof DemoDesignSystemTestsComponentSizeRoute
  '/demo/design-system/theming/examples': typeof DemoDesignSystemThemingExamplesRoute
  '/demo/design-system/theming/opacity-utilities': typeof DemoDesignSystemThemingOpacityUtilitiesRoute
  '/demo/design-system/theming/tailwind-plugin': typeof DemoDesignSystemThemingTailwindPluginRoute
  '/demo/design-system/theming/theme-utilities': typeof DemoDesignSystemThemingThemeUtilitiesRoute
  '/demo/design-system/foundations/': typeof DemoDesignSystemFoundationsIndexRoute
  '/demo/design-system/interactive/': typeof DemoDesignSystemInteractiveIndexRoute
  '/demo/design-system/radix/': typeof DemoDesignSystemRadixIndexRoute
  '/demo/design-system/specialty/': typeof DemoDesignSystemSpecialtyIndexRoute
  '/demo/design-system/tests/': typeof DemoDesignSystemTestsIndexRoute
  '/demo/design-system/theming/': typeof DemoDesignSystemThemingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/gem': typeof GemRoute
  '/demo': typeof DemoIndexRoute
  '/demo/3d': typeof Demo3dIndexRoute
  '/demo/3d/hero': typeof Demo3dHeroRoute
  '/demo/tests/component-size-test': typeof DemoTestsComponentSizeTestRoute
  '/demo/design-system': typeof DemoDesignSystemIndexRoute
  '/demo/tests': typeof DemoTestsIndexRoute
  '/demo/3d/bob': typeof ImmersiveDemo3dBobRoute
  '/demo/3d/drill': typeof ImmersiveDemo3dDrillRoute
  '/demo/3d/gem': typeof ImmersiveDemo3dGemRoute
  '/demo/3d/rune': typeof ImmersiveDemo3dRuneRoute
  '/demo/design-system/foundations/buttons': typeof DemoDesignSystemFoundationsButtonsRoute
  '/demo/design-system/foundations/cards': typeof DemoDesignSystemFoundationsCardsRoute
  '/demo/design-system/foundations/labels': typeof DemoDesignSystemFoundationsLabelsRoute
  '/demo/design-system/interactive/collapsible': typeof DemoDesignSystemInteractiveCollapsibleRoute
  '/demo/design-system/interactive/dropdown': typeof DemoDesignSystemInteractiveDropdownRoute
  '/demo/design-system/interactive/navigation-menu': typeof DemoDesignSystemInteractiveNavigationMenuRoute
  '/demo/design-system/interactive/slider': typeof DemoDesignSystemInteractiveSliderRoute
  '/demo/design-system/interactive/switch': typeof DemoDesignSystemInteractiveSwitchRoute
  '/demo/design-system/interactive/tabs': typeof DemoDesignSystemInteractiveTabsRoute
  '/demo/design-system/interactive/toast': typeof DemoDesignSystemInteractiveToastRoute
  '/demo/design-system/radix/accordion': typeof DemoDesignSystemRadixAccordionRoute
  '/demo/design-system/radix/hover-card': typeof DemoDesignSystemRadixHoverCardRoute
  '/demo/design-system/radix/popover': typeof DemoDesignSystemRadixPopoverRoute
  '/demo/design-system/radix/radix-examples': typeof DemoDesignSystemRadixRadixExamplesRoute
  '/demo/design-system/radix/scroll-area': typeof DemoDesignSystemRadixScrollAreaRoute
  '/demo/design-system/radix/select': typeof DemoDesignSystemRadixSelectRoute
  '/demo/design-system/specialty/domain-badge': typeof DemoDesignSystemSpecialtyDomainBadgeRoute
  '/demo/design-system/tests/component-size': typeof DemoDesignSystemTestsComponentSizeRoute
  '/demo/design-system/theming/examples': typeof DemoDesignSystemThemingExamplesRoute
  '/demo/design-system/theming/opacity-utilities': typeof DemoDesignSystemThemingOpacityUtilitiesRoute
  '/demo/design-system/theming/tailwind-plugin': typeof DemoDesignSystemThemingTailwindPluginRoute
  '/demo/design-system/theming/theme-utilities': typeof DemoDesignSystemThemingThemeUtilitiesRoute
  '/demo/design-system/foundations': typeof DemoDesignSystemFoundationsIndexRoute
  '/demo/design-system/interactive': typeof DemoDesignSystemInteractiveIndexRoute
  '/demo/design-system/radix': typeof DemoDesignSystemRadixIndexRoute
  '/demo/design-system/specialty': typeof DemoDesignSystemSpecialtyIndexRoute
  '/demo/design-system/tests': typeof DemoDesignSystemTestsIndexRoute
  '/demo/design-system/theming': typeof DemoDesignSystemThemingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_immersive': typeof ImmersiveRouteWithChildren
  '/demo': typeof DemoRouteWithChildren
  '/gem': typeof GemRoute
  '/demo/3d': typeof Demo3dRouteWithChildren
  '/demo/design-system': typeof DemoDesignSystemRouteWithChildren
  '/demo/tests': typeof DemoTestsRouteWithChildren
  '/demo/': typeof DemoIndexRoute
  '/_immersive/demo/3d': typeof ImmersiveDemo3dRouteWithChildren
  '/demo/3d/hero': typeof Demo3dHeroRoute
  '/demo/design-system/foundations': typeof DemoDesignSystemFoundationsRouteWithChildren
  '/demo/design-system/interactive': typeof DemoDesignSystemInteractiveRouteWithChildren
  '/demo/design-system/radix': typeof DemoDesignSystemRadixRouteWithChildren
  '/demo/design-system/specialty': typeof DemoDesignSystemSpecialtyRouteWithChildren
  '/demo/design-system/tests': typeof DemoDesignSystemTestsRouteWithChildren
  '/demo/design-system/theming': typeof DemoDesignSystemThemingRouteWithChildren
  '/demo/tests/component-size-test': typeof DemoTestsComponentSizeTestRoute
  '/demo/3d/': typeof Demo3dIndexRoute
  '/demo/design-system/': typeof DemoDesignSystemIndexRoute
  '/demo/tests/': typeof DemoTestsIndexRoute
  '/_immersive/demo/3d/bob': typeof ImmersiveDemo3dBobRoute
  '/_immersive/demo/3d/drill': typeof ImmersiveDemo3dDrillRoute
  '/_immersive/demo/3d/gem': typeof ImmersiveDemo3dGemRoute
  '/_immersive/demo/3d/rune': typeof ImmersiveDemo3dRuneRoute
  '/demo/design-system/foundations/buttons': typeof DemoDesignSystemFoundationsButtonsRoute
  '/demo/design-system/foundations/cards': typeof DemoDesignSystemFoundationsCardsRoute
  '/demo/design-system/foundations/labels': typeof DemoDesignSystemFoundationsLabelsRoute
  '/demo/design-system/interactive/collapsible': typeof DemoDesignSystemInteractiveCollapsibleRoute
  '/demo/design-system/interactive/dropdown': typeof DemoDesignSystemInteractiveDropdownRoute
  '/demo/design-system/interactive/navigation-menu': typeof DemoDesignSystemInteractiveNavigationMenuRoute
  '/demo/design-system/interactive/slider': typeof DemoDesignSystemInteractiveSliderRoute
  '/demo/design-system/interactive/switch': typeof DemoDesignSystemInteractiveSwitchRoute
  '/demo/design-system/interactive/tabs': typeof DemoDesignSystemInteractiveTabsRoute
  '/demo/design-system/interactive/toast': typeof DemoDesignSystemInteractiveToastRoute
  '/demo/design-system/radix/accordion': typeof DemoDesignSystemRadixAccordionRoute
  '/demo/design-system/radix/hover-card': typeof DemoDesignSystemRadixHoverCardRoute
  '/demo/design-system/radix/popover': typeof DemoDesignSystemRadixPopoverRoute
  '/demo/design-system/radix/radix-examples': typeof DemoDesignSystemRadixRadixExamplesRoute
  '/demo/design-system/radix/scroll-area': typeof DemoDesignSystemRadixScrollAreaRoute
  '/demo/design-system/radix/select': typeof DemoDesignSystemRadixSelectRoute
  '/demo/design-system/specialty/domain-badge': typeof DemoDesignSystemSpecialtyDomainBadgeRoute
  '/demo/design-system/tests/component-size': typeof DemoDesignSystemTestsComponentSizeRoute
  '/demo/design-system/theming/examples': typeof DemoDesignSystemThemingExamplesRoute
  '/demo/design-system/theming/opacity-utilities': typeof DemoDesignSystemThemingOpacityUtilitiesRoute
  '/demo/design-system/theming/tailwind-plugin': typeof DemoDesignSystemThemingTailwindPluginRoute
  '/demo/design-system/theming/theme-utilities': typeof DemoDesignSystemThemingThemeUtilitiesRoute
  '/demo/design-system/foundations/': typeof DemoDesignSystemFoundationsIndexRoute
  '/demo/design-system/interactive/': typeof DemoDesignSystemInteractiveIndexRoute
  '/demo/design-system/radix/': typeof DemoDesignSystemRadixIndexRoute
  '/demo/design-system/specialty/': typeof DemoDesignSystemSpecialtyIndexRoute
  '/demo/design-system/tests/': typeof DemoDesignSystemTestsIndexRoute
  '/demo/design-system/theming/': typeof DemoDesignSystemThemingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/demo'
    | '/gem'
    | '/demo/3d'
    | '/demo/design-system'
    | '/demo/tests'
    | '/demo/'
    | '/demo/3d/hero'
    | '/demo/design-system/foundations'
    | '/demo/design-system/interactive'
    | '/demo/design-system/radix'
    | '/demo/design-system/specialty'
    | '/demo/design-system/tests'
    | '/demo/design-system/theming'
    | '/demo/tests/component-size-test'
    | '/demo/3d/'
    | '/demo/design-system/'
    | '/demo/tests/'
    | '/demo/3d/bob'
    | '/demo/3d/drill'
    | '/demo/3d/gem'
    | '/demo/3d/rune'
    | '/demo/design-system/foundations/buttons'
    | '/demo/design-system/foundations/cards'
    | '/demo/design-system/foundations/labels'
    | '/demo/design-system/interactive/collapsible'
    | '/demo/design-system/interactive/dropdown'
    | '/demo/design-system/interactive/navigation-menu'
    | '/demo/design-system/interactive/slider'
    | '/demo/design-system/interactive/switch'
    | '/demo/design-system/interactive/tabs'
    | '/demo/design-system/interactive/toast'
    | '/demo/design-system/radix/accordion'
    | '/demo/design-system/radix/hover-card'
    | '/demo/design-system/radix/popover'
    | '/demo/design-system/radix/radix-examples'
    | '/demo/design-system/radix/scroll-area'
    | '/demo/design-system/radix/select'
    | '/demo/design-system/specialty/domain-badge'
    | '/demo/design-system/tests/component-size'
    | '/demo/design-system/theming/examples'
    | '/demo/design-system/theming/opacity-utilities'
    | '/demo/design-system/theming/tailwind-plugin'
    | '/demo/design-system/theming/theme-utilities'
    | '/demo/design-system/foundations/'
    | '/demo/design-system/interactive/'
    | '/demo/design-system/radix/'
    | '/demo/design-system/specialty/'
    | '/demo/design-system/tests/'
    | '/demo/design-system/theming/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/gem'
    | '/demo'
    | '/demo/3d'
    | '/demo/3d/hero'
    | '/demo/tests/component-size-test'
    | '/demo/design-system'
    | '/demo/tests'
    | '/demo/3d/bob'
    | '/demo/3d/drill'
    | '/demo/3d/gem'
    | '/demo/3d/rune'
    | '/demo/design-system/foundations/buttons'
    | '/demo/design-system/foundations/cards'
    | '/demo/design-system/foundations/labels'
    | '/demo/design-system/interactive/collapsible'
    | '/demo/design-system/interactive/dropdown'
    | '/demo/design-system/interactive/navigation-menu'
    | '/demo/design-system/interactive/slider'
    | '/demo/design-system/interactive/switch'
    | '/demo/design-system/interactive/tabs'
    | '/demo/design-system/interactive/toast'
    | '/demo/design-system/radix/accordion'
    | '/demo/design-system/radix/hover-card'
    | '/demo/design-system/radix/popover'
    | '/demo/design-system/radix/radix-examples'
    | '/demo/design-system/radix/scroll-area'
    | '/demo/design-system/radix/select'
    | '/demo/design-system/specialty/domain-badge'
    | '/demo/design-system/tests/component-size'
    | '/demo/design-system/theming/examples'
    | '/demo/design-system/theming/opacity-utilities'
    | '/demo/design-system/theming/tailwind-plugin'
    | '/demo/design-system/theming/theme-utilities'
    | '/demo/design-system/foundations'
    | '/demo/design-system/interactive'
    | '/demo/design-system/radix'
    | '/demo/design-system/specialty'
    | '/demo/design-system/tests'
    | '/demo/design-system/theming'
  id:
    | '__root__'
    | '/'
    | '/_immersive'
    | '/demo'
    | '/gem'
    | '/demo/3d'
    | '/demo/design-system'
    | '/demo/tests'
    | '/demo/'
    | '/_immersive/demo/3d'
    | '/demo/3d/hero'
    | '/demo/design-system/foundations'
    | '/demo/design-system/interactive'
    | '/demo/design-system/radix'
    | '/demo/design-system/specialty'
    | '/demo/design-system/tests'
    | '/demo/design-system/theming'
    | '/demo/tests/component-size-test'
    | '/demo/3d/'
    | '/demo/design-system/'
    | '/demo/tests/'
    | '/_immersive/demo/3d/bob'
    | '/_immersive/demo/3d/drill'
    | '/_immersive/demo/3d/gem'
    | '/_immersive/demo/3d/rune'
    | '/demo/design-system/foundations/buttons'
    | '/demo/design-system/foundations/cards'
    | '/demo/design-system/foundations/labels'
    | '/demo/design-system/interactive/collapsible'
    | '/demo/design-system/interactive/dropdown'
    | '/demo/design-system/interactive/navigation-menu'
    | '/demo/design-system/interactive/slider'
    | '/demo/design-system/interactive/switch'
    | '/demo/design-system/interactive/tabs'
    | '/demo/design-system/interactive/toast'
    | '/demo/design-system/radix/accordion'
    | '/demo/design-system/radix/hover-card'
    | '/demo/design-system/radix/popover'
    | '/demo/design-system/radix/radix-examples'
    | '/demo/design-system/radix/scroll-area'
    | '/demo/design-system/radix/select'
    | '/demo/design-system/specialty/domain-badge'
    | '/demo/design-system/tests/component-size'
    | '/demo/design-system/theming/examples'
    | '/demo/design-system/theming/opacity-utilities'
    | '/demo/design-system/theming/tailwind-plugin'
    | '/demo/design-system/theming/theme-utilities'
    | '/demo/design-system/foundations/'
    | '/demo/design-system/interactive/'
    | '/demo/design-system/radix/'
    | '/demo/design-system/specialty/'
    | '/demo/design-system/tests/'
    | '/demo/design-system/theming/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ImmersiveRoute: typeof ImmersiveRouteWithChildren
  DemoRoute: typeof DemoRouteWithChildren
  GemRoute: typeof GemRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_immersive': {
      id: '/_immersive'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ImmersiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gem': {
      id: '/gem'
      path: '/gem'
      fullPath: '/gem'
      preLoaderRoute: typeof GemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/': {
      id: '/demo/'
      path: '/'
      fullPath: '/demo/'
      preLoaderRoute: typeof DemoIndexRouteImport
      parentRoute: typeof DemoRoute
    }
    '/demo/3d': {
      id: '/demo/3d'
      path: '/3d'
      fullPath: '/demo/3d'
      preLoaderRoute: typeof Demo3dRouteImport
      parentRoute: typeof DemoRoute
    }
    '/demo/design-system': {
      id: '/demo/design-system'
      path: '/design-system'
      fullPath: '/demo/design-system'
      preLoaderRoute: typeof DemoDesignSystemRouteImport
      parentRoute: typeof DemoRoute
    }
    '/demo/tests': {
      id: '/demo/tests'
      path: '/tests'
      fullPath: '/demo/tests'
      preLoaderRoute: typeof DemoTestsRouteImport
      parentRoute: typeof DemoRoute
    }
    '/_immersive/demo/3d': {
      id: '/_immersive/demo/3d'
      path: '/demo/3d'
      fullPath: '/demo/3d'
      preLoaderRoute: typeof ImmersiveDemo3dRouteImport
      parentRoute: typeof ImmersiveRoute
    }
    '/demo/3d/': {
      id: '/demo/3d/'
      path: '/'
      fullPath: '/demo/3d/'
      preLoaderRoute: typeof Demo3dIndexRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/3d/hero': {
      id: '/demo/3d/hero'
      path: '/hero'
      fullPath: '/demo/3d/hero'
      preLoaderRoute: typeof Demo3dHeroRouteImport
      parentRoute: typeof Demo3dRoute
    }
    '/demo/design-system/': {
      id: '/demo/design-system/'
      path: '/'
      fullPath: '/demo/design-system/'
      preLoaderRoute: typeof DemoDesignSystemIndexRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/foundations': {
      id: '/demo/design-system/foundations'
      path: '/foundations'
      fullPath: '/demo/design-system/foundations'
      preLoaderRoute: typeof DemoDesignSystemFoundationsRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/interactive': {
      id: '/demo/design-system/interactive'
      path: '/interactive'
      fullPath: '/demo/design-system/interactive'
      preLoaderRoute: typeof DemoDesignSystemInteractiveRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/radix': {
      id: '/demo/design-system/radix'
      path: '/radix'
      fullPath: '/demo/design-system/radix'
      preLoaderRoute: typeof DemoDesignSystemRadixRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/specialty': {
      id: '/demo/design-system/specialty'
      path: '/specialty'
      fullPath: '/demo/design-system/specialty'
      preLoaderRoute: typeof DemoDesignSystemSpecialtyRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/tests': {
      id: '/demo/design-system/tests'
      path: '/tests'
      fullPath: '/demo/design-system/tests'
      preLoaderRoute: typeof DemoDesignSystemTestsRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/design-system/theming': {
      id: '/demo/design-system/theming'
      path: '/theming'
      fullPath: '/demo/design-system/theming'
      preLoaderRoute: typeof DemoDesignSystemThemingRouteImport
      parentRoute: typeof DemoDesignSystemRoute
    }
    '/demo/tests/': {
      id: '/demo/tests/'
      path: '/'
      fullPath: '/demo/tests/'
      preLoaderRoute: typeof DemoTestsIndexRouteImport
      parentRoute: typeof DemoTestsRoute
    }
    '/demo/tests/component-size-test': {
      id: '/demo/tests/component-size-test'
      path: '/component-size-test'
      fullPath: '/demo/tests/component-size-test'
      preLoaderRoute: typeof DemoTestsComponentSizeTestRouteImport
      parentRoute: typeof DemoTestsRoute
    }
    '/_immersive/demo/3d/bob': {
      id: '/_immersive/demo/3d/bob'
      path: '/bob'
      fullPath: '/demo/3d/bob'
      preLoaderRoute: typeof ImmersiveDemo3dBobRouteImport
      parentRoute: typeof ImmersiveDemo3dRoute
    }
    '/_immersive/demo/3d/drill': {
      id: '/_immersive/demo/3d/drill'
      path: '/drill'
      fullPath: '/demo/3d/drill'
      preLoaderRoute: typeof ImmersiveDemo3dDrillRouteImport
      parentRoute: typeof ImmersiveDemo3dRoute
    }
    '/_immersive/demo/3d/gem': {
      id: '/_immersive/demo/3d/gem'
      path: '/gem'
      fullPath: '/demo/3d/gem'
      preLoaderRoute: typeof ImmersiveDemo3dGemRouteImport
      parentRoute: typeof ImmersiveDemo3dRoute
    }
    '/_immersive/demo/3d/rune': {
      id: '/_immersive/demo/3d/rune'
      path: '/rune'
      fullPath: '/demo/3d/rune'
      preLoaderRoute: typeof ImmersiveDemo3dRuneRouteImport
      parentRoute: typeof ImmersiveDemo3dRoute
    }
    '/demo/design-system/foundations/': {
      id: '/demo/design-system/foundations/'
      path: '/'
      fullPath: '/demo/design-system/foundations/'
      preLoaderRoute: typeof DemoDesignSystemFoundationsIndexRouteImport
      parentRoute: typeof DemoDesignSystemFoundationsRoute
    }
    '/demo/design-system/foundations/buttons': {
      id: '/demo/design-system/foundations/buttons'
      path: '/buttons'
      fullPath: '/demo/design-system/foundations/buttons'
      preLoaderRoute: typeof DemoDesignSystemFoundationsButtonsRouteImport
      parentRoute: typeof DemoDesignSystemFoundationsRoute
    }
    '/demo/design-system/foundations/cards': {
      id: '/demo/design-system/foundations/cards'
      path: '/cards'
      fullPath: '/demo/design-system/foundations/cards'
      preLoaderRoute: typeof DemoDesignSystemFoundationsCardsRouteImport
      parentRoute: typeof DemoDesignSystemFoundationsRoute
    }
    '/demo/design-system/foundations/labels': {
      id: '/demo/design-system/foundations/labels'
      path: '/labels'
      fullPath: '/demo/design-system/foundations/labels'
      preLoaderRoute: typeof DemoDesignSystemFoundationsLabelsRouteImport
      parentRoute: typeof DemoDesignSystemFoundationsRoute
    }
    '/demo/design-system/interactive/': {
      id: '/demo/design-system/interactive/'
      path: '/'
      fullPath: '/demo/design-system/interactive/'
      preLoaderRoute: typeof DemoDesignSystemInteractiveIndexRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/collapsible': {
      id: '/demo/design-system/interactive/collapsible'
      path: '/collapsible'
      fullPath: '/demo/design-system/interactive/collapsible'
      preLoaderRoute: typeof DemoDesignSystemInteractiveCollapsibleRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/dropdown': {
      id: '/demo/design-system/interactive/dropdown'
      path: '/dropdown'
      fullPath: '/demo/design-system/interactive/dropdown'
      preLoaderRoute: typeof DemoDesignSystemInteractiveDropdownRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/navigation-menu': {
      id: '/demo/design-system/interactive/navigation-menu'
      path: '/navigation-menu'
      fullPath: '/demo/design-system/interactive/navigation-menu'
      preLoaderRoute: typeof DemoDesignSystemInteractiveNavigationMenuRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/slider': {
      id: '/demo/design-system/interactive/slider'
      path: '/slider'
      fullPath: '/demo/design-system/interactive/slider'
      preLoaderRoute: typeof DemoDesignSystemInteractiveSliderRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/switch': {
      id: '/demo/design-system/interactive/switch'
      path: '/switch'
      fullPath: '/demo/design-system/interactive/switch'
      preLoaderRoute: typeof DemoDesignSystemInteractiveSwitchRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/tabs': {
      id: '/demo/design-system/interactive/tabs'
      path: '/tabs'
      fullPath: '/demo/design-system/interactive/tabs'
      preLoaderRoute: typeof DemoDesignSystemInteractiveTabsRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/interactive/toast': {
      id: '/demo/design-system/interactive/toast'
      path: '/toast'
      fullPath: '/demo/design-system/interactive/toast'
      preLoaderRoute: typeof DemoDesignSystemInteractiveToastRouteImport
      parentRoute: typeof DemoDesignSystemInteractiveRoute
    }
    '/demo/design-system/radix/': {
      id: '/demo/design-system/radix/'
      path: '/'
      fullPath: '/demo/design-system/radix/'
      preLoaderRoute: typeof DemoDesignSystemRadixIndexRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/accordion': {
      id: '/demo/design-system/radix/accordion'
      path: '/accordion'
      fullPath: '/demo/design-system/radix/accordion'
      preLoaderRoute: typeof DemoDesignSystemRadixAccordionRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/hover-card': {
      id: '/demo/design-system/radix/hover-card'
      path: '/hover-card'
      fullPath: '/demo/design-system/radix/hover-card'
      preLoaderRoute: typeof DemoDesignSystemRadixHoverCardRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/popover': {
      id: '/demo/design-system/radix/popover'
      path: '/popover'
      fullPath: '/demo/design-system/radix/popover'
      preLoaderRoute: typeof DemoDesignSystemRadixPopoverRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/radix-examples': {
      id: '/demo/design-system/radix/radix-examples'
      path: '/radix-examples'
      fullPath: '/demo/design-system/radix/radix-examples'
      preLoaderRoute: typeof DemoDesignSystemRadixRadixExamplesRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/scroll-area': {
      id: '/demo/design-system/radix/scroll-area'
      path: '/scroll-area'
      fullPath: '/demo/design-system/radix/scroll-area'
      preLoaderRoute: typeof DemoDesignSystemRadixScrollAreaRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/radix/select': {
      id: '/demo/design-system/radix/select'
      path: '/select'
      fullPath: '/demo/design-system/radix/select'
      preLoaderRoute: typeof DemoDesignSystemRadixSelectRouteImport
      parentRoute: typeof DemoDesignSystemRadixRoute
    }
    '/demo/design-system/specialty/': {
      id: '/demo/design-system/specialty/'
      path: '/'
      fullPath: '/demo/design-system/specialty/'
      preLoaderRoute: typeof DemoDesignSystemSpecialtyIndexRouteImport
      parentRoute: typeof DemoDesignSystemSpecialtyRoute
    }
    '/demo/design-system/specialty/domain-badge': {
      id: '/demo/design-system/specialty/domain-badge'
      path: '/domain-badge'
      fullPath: '/demo/design-system/specialty/domain-badge'
      preLoaderRoute: typeof DemoDesignSystemSpecialtyDomainBadgeRouteImport
      parentRoute: typeof DemoDesignSystemSpecialtyRoute
    }
    '/demo/design-system/tests/': {
      id: '/demo/design-system/tests/'
      path: '/'
      fullPath: '/demo/design-system/tests/'
      preLoaderRoute: typeof DemoDesignSystemTestsIndexRouteImport
      parentRoute: typeof DemoDesignSystemTestsRoute
    }
    '/demo/design-system/tests/component-size': {
      id: '/demo/design-system/tests/component-size'
      path: '/component-size'
      fullPath: '/demo/design-system/tests/component-size'
      preLoaderRoute: typeof DemoDesignSystemTestsComponentSizeRouteImport
      parentRoute: typeof DemoDesignSystemTestsRoute
    }
    '/demo/design-system/theming/': {
      id: '/demo/design-system/theming/'
      path: '/'
      fullPath: '/demo/design-system/theming/'
      preLoaderRoute: typeof DemoDesignSystemThemingIndexRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
    '/demo/design-system/theming/examples': {
      id: '/demo/design-system/theming/examples'
      path: '/examples'
      fullPath: '/demo/design-system/theming/examples'
      preLoaderRoute: typeof DemoDesignSystemThemingExamplesRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
    '/demo/design-system/theming/opacity-utilities': {
      id: '/demo/design-system/theming/opacity-utilities'
      path: '/opacity-utilities'
      fullPath: '/demo/design-system/theming/opacity-utilities'
      preLoaderRoute: typeof DemoDesignSystemThemingOpacityUtilitiesRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
    '/demo/design-system/theming/tailwind-plugin': {
      id: '/demo/design-system/theming/tailwind-plugin'
      path: '/tailwind-plugin'
      fullPath: '/demo/design-system/theming/tailwind-plugin'
      preLoaderRoute: typeof DemoDesignSystemThemingTailwindPluginRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
    '/demo/design-system/theming/theme-utilities': {
      id: '/demo/design-system/theming/theme-utilities'
      path: '/theme-utilities'
      fullPath: '/demo/design-system/theming/theme-utilities'
      preLoaderRoute: typeof DemoDesignSystemThemingThemeUtilitiesRouteImport
      parentRoute: typeof DemoDesignSystemThemingRoute
    }
  }
}

interface ImmersiveDemo3dRouteChildren {
  ImmersiveDemo3dBobRoute: typeof ImmersiveDemo3dBobRoute
  ImmersiveDemo3dDrillRoute: typeof ImmersiveDemo3dDrillRoute
  ImmersiveDemo3dGemRoute: typeof ImmersiveDemo3dGemRoute
  ImmersiveDemo3dRuneRoute: typeof ImmersiveDemo3dRuneRoute
}

const ImmersiveDemo3dRouteChildren: ImmersiveDemo3dRouteChildren = {
  ImmersiveDemo3dBobRoute: ImmersiveDemo3dBobRoute,
  ImmersiveDemo3dDrillRoute: ImmersiveDemo3dDrillRoute,
  ImmersiveDemo3dGemRoute: ImmersiveDemo3dGemRoute,
  ImmersiveDemo3dRuneRoute: ImmersiveDemo3dRuneRoute,
}

const ImmersiveDemo3dRouteWithChildren = ImmersiveDemo3dRoute._addFileChildren(
  ImmersiveDemo3dRouteChildren,
)

interface ImmersiveRouteChildren {
  ImmersiveDemo3dRoute: typeof ImmersiveDemo3dRouteWithChildren
}

const ImmersiveRouteChildren: ImmersiveRouteChildren = {
  ImmersiveDemo3dRoute: ImmersiveDemo3dRouteWithChildren,
}

const ImmersiveRouteWithChildren = ImmersiveRoute._addFileChildren(
  ImmersiveRouteChildren,
)

interface Demo3dRouteChildren {
  Demo3dHeroRoute: typeof Demo3dHeroRoute
  Demo3dIndexRoute: typeof Demo3dIndexRoute
}

const Demo3dRouteChildren: Demo3dRouteChildren = {
  Demo3dHeroRoute: Demo3dHeroRoute,
  Demo3dIndexRoute: Demo3dIndexRoute,
}

const Demo3dRouteWithChildren =
  Demo3dRoute._addFileChildren(Demo3dRouteChildren)

interface DemoDesignSystemFoundationsRouteChildren {
  DemoDesignSystemFoundationsButtonsRoute: typeof DemoDesignSystemFoundationsButtonsRoute
  DemoDesignSystemFoundationsCardsRoute: typeof DemoDesignSystemFoundationsCardsRoute
  DemoDesignSystemFoundationsLabelsRoute: typeof DemoDesignSystemFoundationsLabelsRoute
  DemoDesignSystemFoundationsIndexRoute: typeof DemoDesignSystemFoundationsIndexRoute
}

const DemoDesignSystemFoundationsRouteChildren: DemoDesignSystemFoundationsRouteChildren =
  {
    DemoDesignSystemFoundationsButtonsRoute:
      DemoDesignSystemFoundationsButtonsRoute,
    DemoDesignSystemFoundationsCardsRoute:
      DemoDesignSystemFoundationsCardsRoute,
    DemoDesignSystemFoundationsLabelsRoute:
      DemoDesignSystemFoundationsLabelsRoute,
    DemoDesignSystemFoundationsIndexRoute:
      DemoDesignSystemFoundationsIndexRoute,
  }

const DemoDesignSystemFoundationsRouteWithChildren =
  DemoDesignSystemFoundationsRoute._addFileChildren(
    DemoDesignSystemFoundationsRouteChildren,
  )

interface DemoDesignSystemInteractiveRouteChildren {
  DemoDesignSystemInteractiveCollapsibleRoute: typeof DemoDesignSystemInteractiveCollapsibleRoute
  DemoDesignSystemInteractiveDropdownRoute: typeof DemoDesignSystemInteractiveDropdownRoute
  DemoDesignSystemInteractiveNavigationMenuRoute: typeof DemoDesignSystemInteractiveNavigationMenuRoute
  DemoDesignSystemInteractiveSliderRoute: typeof DemoDesignSystemInteractiveSliderRoute
  DemoDesignSystemInteractiveSwitchRoute: typeof DemoDesignSystemInteractiveSwitchRoute
  DemoDesignSystemInteractiveTabsRoute: typeof DemoDesignSystemInteractiveTabsRoute
  DemoDesignSystemInteractiveToastRoute: typeof DemoDesignSystemInteractiveToastRoute
  DemoDesignSystemInteractiveIndexRoute: typeof DemoDesignSystemInteractiveIndexRoute
}

const DemoDesignSystemInteractiveRouteChildren: DemoDesignSystemInteractiveRouteChildren =
  {
    DemoDesignSystemInteractiveCollapsibleRoute:
      DemoDesignSystemInteractiveCollapsibleRoute,
    DemoDesignSystemInteractiveDropdownRoute:
      DemoDesignSystemInteractiveDropdownRoute,
    DemoDesignSystemInteractiveNavigationMenuRoute:
      DemoDesignSystemInteractiveNavigationMenuRoute,
    DemoDesignSystemInteractiveSliderRoute:
      DemoDesignSystemInteractiveSliderRoute,
    DemoDesignSystemInteractiveSwitchRoute:
      DemoDesignSystemInteractiveSwitchRoute,
    DemoDesignSystemInteractiveTabsRoute: DemoDesignSystemInteractiveTabsRoute,
    DemoDesignSystemInteractiveToastRoute:
      DemoDesignSystemInteractiveToastRoute,
    DemoDesignSystemInteractiveIndexRoute:
      DemoDesignSystemInteractiveIndexRoute,
  }

const DemoDesignSystemInteractiveRouteWithChildren =
  DemoDesignSystemInteractiveRoute._addFileChildren(
    DemoDesignSystemInteractiveRouteChildren,
  )

interface DemoDesignSystemRadixRouteChildren {
  DemoDesignSystemRadixAccordionRoute: typeof DemoDesignSystemRadixAccordionRoute
  DemoDesignSystemRadixHoverCardRoute: typeof DemoDesignSystemRadixHoverCardRoute
  DemoDesignSystemRadixPopoverRoute: typeof DemoDesignSystemRadixPopoverRoute
  DemoDesignSystemRadixRadixExamplesRoute: typeof DemoDesignSystemRadixRadixExamplesRoute
  DemoDesignSystemRadixScrollAreaRoute: typeof DemoDesignSystemRadixScrollAreaRoute
  DemoDesignSystemRadixSelectRoute: typeof DemoDesignSystemRadixSelectRoute
  DemoDesignSystemRadixIndexRoute: typeof DemoDesignSystemRadixIndexRoute
}

const DemoDesignSystemRadixRouteChildren: DemoDesignSystemRadixRouteChildren = {
  DemoDesignSystemRadixAccordionRoute: DemoDesignSystemRadixAccordionRoute,
  DemoDesignSystemRadixHoverCardRoute: DemoDesignSystemRadixHoverCardRoute,
  DemoDesignSystemRadixPopoverRoute: DemoDesignSystemRadixPopoverRoute,
  DemoDesignSystemRadixRadixExamplesRoute:
    DemoDesignSystemRadixRadixExamplesRoute,
  DemoDesignSystemRadixScrollAreaRoute: DemoDesignSystemRadixScrollAreaRoute,
  DemoDesignSystemRadixSelectRoute: DemoDesignSystemRadixSelectRoute,
  DemoDesignSystemRadixIndexRoute: DemoDesignSystemRadixIndexRoute,
}

const DemoDesignSystemRadixRouteWithChildren =
  DemoDesignSystemRadixRoute._addFileChildren(
    DemoDesignSystemRadixRouteChildren,
  )

interface DemoDesignSystemSpecialtyRouteChildren {
  DemoDesignSystemSpecialtyDomainBadgeRoute: typeof DemoDesignSystemSpecialtyDomainBadgeRoute
  DemoDesignSystemSpecialtyIndexRoute: typeof DemoDesignSystemSpecialtyIndexRoute
}

const DemoDesignSystemSpecialtyRouteChildren: DemoDesignSystemSpecialtyRouteChildren =
  {
    DemoDesignSystemSpecialtyDomainBadgeRoute:
      DemoDesignSystemSpecialtyDomainBadgeRoute,
    DemoDesignSystemSpecialtyIndexRoute: DemoDesignSystemSpecialtyIndexRoute,
  }

const DemoDesignSystemSpecialtyRouteWithChildren =
  DemoDesignSystemSpecialtyRoute._addFileChildren(
    DemoDesignSystemSpecialtyRouteChildren,
  )

interface DemoDesignSystemTestsRouteChildren {
  DemoDesignSystemTestsComponentSizeRoute: typeof DemoDesignSystemTestsComponentSizeRoute
  DemoDesignSystemTestsIndexRoute: typeof DemoDesignSystemTestsIndexRoute
}

const DemoDesignSystemTestsRouteChildren: DemoDesignSystemTestsRouteChildren = {
  DemoDesignSystemTestsComponentSizeRoute:
    DemoDesignSystemTestsComponentSizeRoute,
  DemoDesignSystemTestsIndexRoute: DemoDesignSystemTestsIndexRoute,
}

const DemoDesignSystemTestsRouteWithChildren =
  DemoDesignSystemTestsRoute._addFileChildren(
    DemoDesignSystemTestsRouteChildren,
  )

interface DemoDesignSystemThemingRouteChildren {
  DemoDesignSystemThemingExamplesRoute: typeof DemoDesignSystemThemingExamplesRoute
  DemoDesignSystemThemingOpacityUtilitiesRoute: typeof DemoDesignSystemThemingOpacityUtilitiesRoute
  DemoDesignSystemThemingTailwindPluginRoute: typeof DemoDesignSystemThemingTailwindPluginRoute
  DemoDesignSystemThemingThemeUtilitiesRoute: typeof DemoDesignSystemThemingThemeUtilitiesRoute
  DemoDesignSystemThemingIndexRoute: typeof DemoDesignSystemThemingIndexRoute
}

const DemoDesignSystemThemingRouteChildren: DemoDesignSystemThemingRouteChildren =
  {
    DemoDesignSystemThemingExamplesRoute: DemoDesignSystemThemingExamplesRoute,
    DemoDesignSystemThemingOpacityUtilitiesRoute:
      DemoDesignSystemThemingOpacityUtilitiesRoute,
    DemoDesignSystemThemingTailwindPluginRoute:
      DemoDesignSystemThemingTailwindPluginRoute,
    DemoDesignSystemThemingThemeUtilitiesRoute:
      DemoDesignSystemThemingThemeUtilitiesRoute,
    DemoDesignSystemThemingIndexRoute: DemoDesignSystemThemingIndexRoute,
  }

const DemoDesignSystemThemingRouteWithChildren =
  DemoDesignSystemThemingRoute._addFileChildren(
    DemoDesignSystemThemingRouteChildren,
  )

interface DemoDesignSystemRouteChildren {
  DemoDesignSystemFoundationsRoute: typeof DemoDesignSystemFoundationsRouteWithChildren
  DemoDesignSystemInteractiveRoute: typeof DemoDesignSystemInteractiveRouteWithChildren
  DemoDesignSystemRadixRoute: typeof DemoDesignSystemRadixRouteWithChildren
  DemoDesignSystemSpecialtyRoute: typeof DemoDesignSystemSpecialtyRouteWithChildren
  DemoDesignSystemTestsRoute: typeof DemoDesignSystemTestsRouteWithChildren
  DemoDesignSystemThemingRoute: typeof DemoDesignSystemThemingRouteWithChildren
  DemoDesignSystemIndexRoute: typeof DemoDesignSystemIndexRoute
}

const DemoDesignSystemRouteChildren: DemoDesignSystemRouteChildren = {
  DemoDesignSystemFoundationsRoute:
    DemoDesignSystemFoundationsRouteWithChildren,
  DemoDesignSystemInteractiveRoute:
    DemoDesignSystemInteractiveRouteWithChildren,
  DemoDesignSystemRadixRoute: DemoDesignSystemRadixRouteWithChildren,
  DemoDesignSystemSpecialtyRoute: DemoDesignSystemSpecialtyRouteWithChildren,
  DemoDesignSystemTestsRoute: DemoDesignSystemTestsRouteWithChildren,
  DemoDesignSystemThemingRoute: DemoDesignSystemThemingRouteWithChildren,
  DemoDesignSystemIndexRoute: DemoDesignSystemIndexRoute,
}

const DemoDesignSystemRouteWithChildren =
  DemoDesignSystemRoute._addFileChildren(DemoDesignSystemRouteChildren)

interface DemoTestsRouteChildren {
  DemoTestsComponentSizeTestRoute: typeof DemoTestsComponentSizeTestRoute
  DemoTestsIndexRoute: typeof DemoTestsIndexRoute
}

const DemoTestsRouteChildren: DemoTestsRouteChildren = {
  DemoTestsComponentSizeTestRoute: DemoTestsComponentSizeTestRoute,
  DemoTestsIndexRoute: DemoTestsIndexRoute,
}

const DemoTestsRouteWithChildren = DemoTestsRoute._addFileChildren(
  DemoTestsRouteChildren,
)

interface DemoRouteChildren {
  Demo3dRoute: typeof Demo3dRouteWithChildren
  DemoDesignSystemRoute: typeof DemoDesignSystemRouteWithChildren
  DemoTestsRoute: typeof DemoTestsRouteWithChildren
  DemoIndexRoute: typeof DemoIndexRoute
}

const DemoRouteChildren: DemoRouteChildren = {
  Demo3dRoute: Demo3dRouteWithChildren,
  DemoDesignSystemRoute: DemoDesignSystemRouteWithChildren,
  DemoTestsRoute: DemoTestsRouteWithChildren,
  DemoIndexRoute: DemoIndexRoute,
}

const DemoRouteWithChildren = DemoRoute._addFileChildren(DemoRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ImmersiveRoute: ImmersiveRouteWithChildren,
  DemoRoute: DemoRouteWithChildren,
  GemRoute: GemRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
